var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    "data-name": "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1302.55 909.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 2388,
    height: 1668,
    transform: "scale(.55)",
    xlinkHref: "../../../../../../Library/Mobile Documents/com~apple~CloudDocs/\\u110C\\u1166\\u1106\\u1169\\u11A8_\\u110B\\u1165\\u11B9\\u1102\\u1173\\u11AB_\\u110B\\u1161\\u1110\\u1173\\u110B\\u116F\\u110F\\u1173.png"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star1.59e5b513bf4e76e63a8329a857b01a05.svg";
export { ForwardRef as ReactComponent };